import { skipToken } from "@reduxjs/toolkit/dist/query";
import {
  PortalEventContextType,
  PortalInviteStatusDto,
  PortalLifecycleStatus,
  useGetPortalNegotiationRoundsQuery,
  type PortalNegotiationRoundDto,
  type PortalSourcingEventDetailDto,
} from "../../../../autogen/bff-api";
import { roundAcceptsBids } from "./roundAcceptsBids";

const isParticipating = (event: PortalSourcingEventDetailDto): boolean =>
  event.myInviteStatus != null &&
  event.myInviteStatus !== PortalInviteStatusDto.NotInvited &&
  event.myInviteStatus !== PortalInviteStatusDto.Declined;

export const portalEventMayHaveRounds = (event: PortalSourcingEventDetailDto): boolean => {
  const isPrivate = event.contextType === PortalEventContextType.Private;
  const isActive = event.lifecycle.status !== PortalLifecycleStatus.Cancelled;
  return isActive && (!isPrivate || isParticipating(event));
};

export const useOpenPortalRound = (event: PortalSourcingEventDetailDto): PortalNegotiationRoundDto | null => {
  const relevant =
    event.lifecycle.status === PortalLifecycleStatus.DeadlinePassed && portalEventMayHaveRounds(event);
  const { data } = useGetPortalNegotiationRoundsQuery(relevant ? { eventId: event.id } : skipToken);
  return (
    (data?.rounds ?? [])
      .filter((round) => roundAcceptsBids(round) && round.isCallerInvited)
      .sort((a, b) => a.roundNumber - b.roundNumber)
      .at(-1) ?? null
  );
};
